import { Button, ButtonProps, CircularProgress } from '@mui/material';
import { FC } from 'react';

interface IAsyncButtonProps extends ButtonProps {
  loading: boolean;
}
export const AsyncButton: FC<IAsyncButtonProps> = (props) => {
  const { loading, children, ...ButtonProps } = props;
  return loading ? (
    <CircularProgress />
  ) : (
    <Button {...ButtonProps}>{children}</Button>
  );
};
